// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SummaryAddress-module__address{margin:1rem 0 2rem;line-height:1.6}.SummaryAddress-module__address.SummaryAddress-module__not-found-error{border:2px solid red;border-radius:2px;padding:.5rem .8rem}", "",{"version":3,"sources":["webpack://src/components/checkout/steps/Summary/SummaryAddress.module.scss"],"names":[],"mappings":"AAAA,gCACE,kBAAA,CACA,eAAA,CAEA,uEACE,oBAAA,CACA,iBAAA,CACA,mBAAA","sourcesContent":[".address {\n  margin: 1rem 0 2rem;\n  line-height: 1.6;\n\n  &.not-found-error {\n    border: 2px solid red;\n    border-radius: 2px;\n    padding: 0.5rem 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"address": "SummaryAddress-module__address",
	"not-found-error": "SummaryAddress-module__not-found-error",
	"notFoundError": "SummaryAddress-module__not-found-error"
};
export default ___CSS_LOADER_EXPORT___;
